import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function PersonalCharacteristics() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  
  return (
    <fieldset>
      <legend>{t("Personal Characteristics")}</legend>
      <input
        PersonnalCharacteristics
        name="personnalCharacteristics"
        onChange={onChange}
        value={searchObject.personnalCharacteristics || ""}
        className="form-control"
      />
    </fieldset>
  );
}
